import { createSelector } from 'reselect';

const getAppState = (state) => state.app;
const getConsoleLanguage = (state) => state.app.language.consoleLanguage;
const getContentLanguage = (state) => state.app.language.contentLanguage;
const getAvailableLanguages = (state) => state.app.language.availableLocales;
const getActionDrawerIsShown = (state) => state.app.actionDrawer.isShown;

/* ============ Selectors ============ */
export const selectAvailableLanguages = createSelector(
    [getAvailableLanguages],
    (availableLanguages = []) => availableLanguages
);

export const selectIsDrawerWrapperShown = createSelector(
    [getAppState],
    ({ drawerWrapperIsShown = false }) => drawerWrapperIsShown
);

export const selectIsActionDrawerShown = createSelector([getActionDrawerIsShown], (isShown) => isShown);

export const selectConsoleLanguage = createSelector(
    [getConsoleLanguage],
    (selectedLang) => selectedLang
);

export const selectConsoleLanguageCode = createSelector(
    [selectConsoleLanguage],
    (selectedLang) => selectedLang.code
);

export const selectContentLanguage = createSelector(
    [getContentLanguage],
    (selectedLang) => selectedLang
);

export const selectContentLanguageCode = createSelector(
    [selectContentLanguage],
    (selectedLang) => selectedLang.code
);
